// Stream profiles — mirrors the middleware's src/apps/streamProfile module.
// A named profile carried on push/pull URLs (?profile=<name>) that the
// middleware expands at admission into the redirection/record shape. NOT to be
// confused with VOD *upload profiles* — always say "stream profile" in UI.

import { OmeApplicationLintResult } from './omeApplication';

export enum StreamProfileRole {
  PUSH = 'push',
  PULL = 'pull',
}

export interface StreamProfileRedirection {
  targetApp: string;
  streamSuffix: string; // template, e.g. "_{height}"
  height?: number;
  tracks?: string[]; // encode names of push.sourceApp
  targetUrlOverride?: string;
  disableIfHost?: boolean; // default true
}

export interface StreamProfileRecord {
  enabled?: boolean;
  uploadProfileId?: string; // middleware upload profile id
  expireAfter?: number; // ms
  tracks?: string[]; // encode names of push.sourceApp
}

export interface StreamProfilePush {
  sourceApp: string;
  redirections: StreamProfileRedirection[];
  record?: StreamProfileRecord;
  recordTracks?: string[]; // deprecated: read as record.tracks
}

// Discriminated by `kind` (absent => "mix", back-compat with older docs).
//  - mix: ABR multiplex playback (suffix/playlist pinned to the engine contract).
//  - ovt: generic edge relay (inject pulling=<PROFILE_PULL_BASE_URL>/<app>/<key>
//    + rewrite the path to <app>/<key>/<pathSelector>).
export interface StreamProfilePullMix {
  kind?: 'mix';
  multiplexSuffix: string; // "_mix"
  playlistFile: string; // "abr"
}

export interface StreamProfilePullOvt {
  kind: 'ovt';
  pathSelector: string; // e.g. "bypass"
}

export type StreamProfilePull = StreamProfilePullMix | StreamProfilePullOvt;

export type StreamProfileLintResult = OmeApplicationLintResult;

export interface StreamProfile {
  _id: string;
  _server: string;
  name: string;
  description?: string;
  roles: StreamProfileRole[];
  push?: StreamProfilePush;
  pull?: StreamProfilePull;
  revision: number;
  updatedBy?: string;
  updatedAt?: string;
  createdAt?: string;
}

export interface StreamProfileTrackIncident {
  at: string;
  kind: 'redirection' | 'record';
  app: string;
  stream: string;
  requested: string[];
  missing: string[];
}

export interface StreamProfileRevisionEntry {
  _id: string;
  profileName: string;
  revision: number;
  action: string;
  author?: string;
  lintResults?: StreamProfileLintResult[];
  createdAt?: string;
}

export interface GetStreamProfilesResponse {
  profiles: StreamProfile[];
  incidents: StreamProfileTrackIncident[];
}

export interface StreamProfileUpsertResponse {
  saved: boolean;
  profile?: StreamProfile;
  lintResults: StreamProfileLintResult[];
}
